import request from '@/utils/request'

export function upload(data,params) {
  return request({
    url: '/api/editor/upload',
    method: 'post',
    data,
    params
  })
}
  //获取上传Token
export function uploadToken() {
  return request({
    url: '/api/file/upload/token',
    method: 'get',
  })
}

  //获取附件上传Token
export function uploadFileToken(params,data) {
  return request({
    url: '/api/uploader/init',
    method: 'post',
    params,
    data
  })
}

  //附件上传
export function uploadFile(params,data) {
  return request({
    url: '/api/uploadfile/upload',
    method: 'post',
    params,
    data,
    timeout: 1800000
  })
}

  //附件提交
export function saveFile(params,data) {
  return request({
    url: '/api/uploader/finished',
    method: 'post',
    params,
    data
  })
}

  //附件删除
export function deleteFile(id,data) {
  return request({
    url: '/api/course_set/'+id+'/manage/delete/materials',
    method: 'post',
    data
  })
}

  //附件列表
export function fileList(id) {
  return request({
    url: '/api/course_set/'+id+'/manage/files',
    method: 'get'
  })
}
